import React, { memo, Fragment } from "react";
import Sidebarlogo from "../../../../../../components/partials/components/sidebar/sidebar-logo";
import Sidebarprofilecard from "../../../../../../components/partials/components/sidebar/sidebar-profile-card";
import BrandAdsVerticalNav from "./brand-ads-vertical-nav";
import * as SettingSelector from "../../../../../../store/setting/selectors";
import { useSelector } from "react-redux";
import useRedirect from "../../../../../../components/custom-hooks/use-redirect";
import { useNavigate, useParams } from "react-router-dom";
import { useGetProjectDetails } from "../../../../../../queries/query-hooks/workspace/workspace-hook";

const BrandsAdsSidebar = memo(() => {
  const { redirectTo } = useRedirect();
  const { project_id, creative_id } = useParams();
  const navigate = useNavigate();

  const { data: projectDetails, isLoading: isProjectDetailsLoading } =
    useGetProjectDetails(project_id);

  const appName = useSelector(SettingSelector.app_name);

  const sidebarColor = useSelector(SettingSelector.sidebar_color);
  const sidebarHide = useSelector(SettingSelector.sidebar_show);
  const sidebarType = useSelector(SettingSelector.sidebar_type);
  const sidebarMenuStyle = useSelector(SettingSelector.sidebar_menu_style);

  const onBackButtonClick = () => {
    if (creative_id) {
      navigate(-1);
    } else {
      redirectTo("workspace/clirnet");
    }
  };

  const onTitleClick = () => {
    // redirectTo(`channel/dashboard/${channel_id}`);
  };

  return (
    <Fragment>
      <aside
        className={`${sidebarColor} ${sidebarType.join(
          " "
        )} ${sidebarMenuStyle} ${
          sidebarHide.join(" ") ? "sidebar-none" : "sidebar"
        } sidebar-base `}
      >
        <Sidebarlogo app_name={appName} />

        <div className="sidebar-body pt-0 data-scrollbar" id="my-scrollbar">
          {
            <Sidebarprofilecard
              title={
                projectDetails && projectDetails?.length > 0
                  ? projectDetails[0]?.project_name
                  : ""
              }
              logo={
                projectDetails && projectDetails?.length > 0
                  ? projectDetails[0]?.project_logo
                  : ""
              }
              isLoading={isProjectDetailsLoading}
              previousPageName={creative_id ? "Project" : "Projects"}
              onBackButtonClick={onBackButtonClick}
              onTitleClick={onTitleClick}
            />
          }

          <hr className="hr-horizontal" />
          <div className="sidebar-list">
            <BrandAdsVerticalNav />
          </div>
        </div>
        <div className="sidebar-footer"></div>
      </aside>
    </Fragment>
  );
});

BrandsAdsSidebar.displayName = "BrandsAdsSidebar";
export default BrandsAdsSidebar;
